// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slotItem {
  border-radius: 50px;
  padding: 6px 12px;
  cursor: pointer;
  position: relative;
  width: auto;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  font-size: 0.75rem;
  gap: 8px;
  box-shadow:
    0 -1px 3px rgba(0, 0, 0, 0.04),
    /* top shadow */ 0 -1px 2px rgba(0, 0, 0, 0.02),
    /* soft top */ 0 1px 3px rgba(0, 0, 0, 0.04),
    /* bottom shadow */ 0 1px 2px rgba(0, 0, 0, 0.02); /* soft bottom */
}

.slotItemDefault {
  background: #fdfefe;
  color: #2d3d54;
  font-weight: 500;
}

.slotItemSelected {
  background: #155dfc;
  color: var(--surface-white);
  font-weight: 500;
}

.slotItem:hover {
  color: #155dfc;
}

.slotItemSelected:hover {
  color: var(--surface-white);
}

.slotItemNotificationBadge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  border-radius: 9999px;
  background-color: rgba(15, 23, 42, 0.08);
  padding: 0 10px;
  font-size: 10px;
  font-weight: 700;
  color: #334155;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/SlotItem/SlotItem.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR;;;;qDAImD,EAAE,gBAAgB;AACvE;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,wCAAwC;EACxC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[".slotItem {\n  border-radius: 50px;\n  padding: 6px 12px;\n  cursor: pointer;\n  position: relative;\n  width: auto;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  font-size: 0.75rem;\n  gap: 8px;\n  box-shadow:\n    0 -1px 3px rgba(0, 0, 0, 0.04),\n    /* top shadow */ 0 -1px 2px rgba(0, 0, 0, 0.02),\n    /* soft top */ 0 1px 3px rgba(0, 0, 0, 0.04),\n    /* bottom shadow */ 0 1px 2px rgba(0, 0, 0, 0.02); /* soft bottom */\n}\n\n.slotItemDefault {\n  background: #fdfefe;\n  color: #2d3d54;\n  font-weight: 500;\n}\n\n.slotItemSelected {\n  background: #155dfc;\n  color: var(--surface-white);\n  font-weight: 500;\n}\n\n.slotItem:hover {\n  color: #155dfc;\n}\n\n.slotItemSelected:hover {\n  color: var(--surface-white);\n}\n\n.slotItemNotificationBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 20px;\n  border-radius: 9999px;\n  background-color: rgba(15, 23, 42, 0.08);\n  padding: 0 10px;\n  font-size: 10px;\n  font-weight: 700;\n  color: #334155;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
